/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, total: NonNullable<unknown> }} Today_Week_OfInputs */

const en_us2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week} of ${i?.total}`)
};

const pt_br2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const es_419_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const pt_pt2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.total}`)
};

const fr_fr2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week} sur ${i?.total}`)
};

const de_de2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week} von ${i?.total}`)
};

const it_it2_today_week_of = /** @type {(inputs: Today_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Week {week} of {total}" |
*
* @param {Today_Week_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_week_of = /** @type {((inputs: Today_Week_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Week_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_week_of(inputs)
	if (locale === "es-419") return es_419_today_week_of(inputs)
	if (locale === "pt-PT") return pt_pt2_today_week_of(inputs)
	if (locale === "fr-FR") return fr_fr2_today_week_of(inputs)
	if (locale === "de-DE") return de_de2_today_week_of(inputs)
	if (locale === "it-IT") return it_it2_today_week_of(inputs)
	return en_us2_today_week_of(inputs)
});
export { today_week_of as "today.week_of" }